import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA6sUC8Gnkk7sqkMv80qSraf-Gl14XhwHs",
  authDomain: "apex-trade-solutions.firebaseapp.com",
  projectId: "apex-trade-solutions",
  storageBucket: "apex-trade-solutions.appspot.com",
  messagingSenderId: "664532430505",
  appId: "1:664532430505:web:fc0eaedcb451a521bc83b8",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDtmNsjSnruKS6ZCs3jwqec0QMqGqGKQWk",
//   authDomain: "finance-v2-e1682.firebaseapp.com",
//   projectId: "finance-v2-e1682",
//   storageBucket: "finance-v2-e1682.appspot.com",
//   messagingSenderId: "133386766551",
//   appId: "1:133386766551:web:e0236afa4a4dc881e20892",
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
